const STORAGE_KEY = 'fc.device_id';
const DEVICE_ID_PATTERN = /^[A-Za-z0-9._-]{8,64}$/;

/**
 * Stable browser device id for anti-abuse checks. Clearing storage creates a new id.
 */
export function getDeviceId(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing && DEVICE_ID_PATTERN.test(existing)) {
      return existing;
    }
    const created = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, created);
    return created;
  } catch {
    return 'unknown';
  }
}
